import Page from '@classes/Page';

export default class Home extends Page {
  constructor() {
    super({
      element: '.home',
      elements: {
        wrapper: '.home__wrapper',
        // Add the video selector
        video: '.home__hero__video',
      },
    });
  }

  create() {
    super.create();
    // const heroVideo = document.querySelector('.hero__video');

    // if (heroVideo) {
    //   // 1. Attempt to play immediately
    //   const promise = heroVideo.play();

    //   if (promise !== undefined) {
    //     promise.catch(error => {
    //       // Autoplay was prevented (Low Power Mode)
    //       console.log('Autoplay blocked. Waiting for user interaction.');

    //       // 2. Play the video on the first click/tap anywhere on the page
    //       const playVideo = () => {
    //         heroVideo.play();
    //         window.removeEventListener('click', playVideo);
    //         window.removeEventListener('touchstart', playVideo);
    //       };

    //       window.addEventListener('click', playVideo);
    //       window.addEventListener('touchstart', playVideo);
    //     });
    //   }
    // }
  }
}
